import { UserActionSheet } from "@/components/ActionSheet";
import { EllipsisHorizontalIc } from "@/components/Elements";
import { PostStatusOption } from "@/utils/listOption";
import { useUpdateAdvertStatusMutation } from "../../api/merchant";

const AdvertAction = ({
  postId,
  status,
}: {
  postId: number;
  status: string;
}) => {
  const [updateAdvertStatus] = useUpdateAdvertStatusMutation();

  const handleStatus = () => {
    updateAdvertStatus({
      postId,
      status:
        status == PostStatusOption.Draft
          ? PostStatusOption.Active
          : PostStatusOption.Draft,
    });
  };

  return (
    <>
      <UserActionSheet
        options={[
          {
            text:
              status == PostStatusOption.Active ? "Save as draft" : "Publish",
            value: "Action0",
            onClick: handleStatus,
          },
        ]}
      >
        <EllipsisHorizontalIc className="h-10 w-10" />
      </UserActionSheet>
    </>
  );
};

export default AdvertAction;
